import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import {
  CategoryBaseInfo,
  GetCategoryAdsCounterResponse,
} from '@/api/types/categories.types';
import { useParseQuery } from '@/hooks/useParseQuery';
import { getCurrentCategoryPath } from '@/hooks/useCurrentCategory/useCurrentCategory.helpers';
import { GET_CATEGORY_ADS_COUNTER } from '@/api/queries/categories.queries';
import { AdKind } from '@/api/types/common.types';
import { isPhoneNumberSearchActive } from '@/features/PhoneNumberSearch';

export function useAdsCounter(
  currentCategory?: CategoryBaseInfo | null,
  adKind?: AdKind
): {
  adsAmount: number | undefined;
  loading?: boolean;
} {
  const router = useRouter();
  const { keywords, price, regionId, propertyOptions, userLegacyId, isShop } =
    useParseQuery();

  const path = getCurrentCategoryPath(router.query.slug);
  const isPhoneNumberSearch = isPhoneNumberSearchActive(
    currentCategory?.path,
    propertyOptions.string
  );
  const filters = {
    price,
    regionId,
    propertyOptions,
    userLegacyId,
    isShop,
  };
  const currentCategoryId = currentCategory?.path.includes('/')
    ? currentCategory?.id
    : '';
  const isBrowser = typeof window !== 'undefined';

  const { data: adsCounterData, loading } =
    useQuery<GetCategoryAdsCounterResponse>(GET_CATEGORY_ADS_COUNTER, {
      variables: {
        path,
        ...((keywords || !isPhoneNumberSearch) && { keywords }),
        filters: { ...filters, categoryId: currentCategoryId },
        adKind,
      },
      skip: !currentCategory || !isBrowser,
      notifyOnNetworkStatusChange: true,
    });

  const adsAmount = adsCounterData?.category?.count;

  return {
    adsAmount,
    loading: !isBrowser || loading,
  };
}
